<template>
    <Login />
</template>

<script>
const Login = () => import("@/pages/login/index.vue");

export default {
    name: "App",
    components: { Login },
};
</script>

<style lang="scss">
* {
    margin: 0;
    padding: 0;
}

html,
body,
#app {
    width: 100%;
    height: 100%;
}
</style>
